<div [ngClass]="{active: _active}" *ngIf="present">
	<div>
		<div class="c1"></div>
		<div class="c2"></div>
		<div class="c4"></div>
		<div class="c3"></div>
	</div>
	<p *ngIf="!!messages && messages.length > 0">{{messages[message_i]}}</p>
</div>
